/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018, 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { REJECTED } from 'mobx-utils';
import PropTypes from 'util/PropTypes';
import RelationshipWidgetView from './RelationshipWidgetView';
import RelationshipVisErrorView from './RelationshipVisErrorView';
import RelationshipStatusBar from './RelationshipStatusBar';

import StringResources from 'nls/StringResources';
const ERROR_DEFAULT_TITLE = StringResources.get('startingPoints_error_title_relationshipDiagram_unavailable');
const ERROR_DEFAULT_DESCRIPTION = StringResources.get('startingPoints_error_instructions_relationshipDiagram');

import './relationshipVisView.scss';

@observer
class RelationshipVisView extends Component {

	/*Main render logic*/
	render() {
		const targetModel = this.props.relationship.getTargetModel();
		const state = targetModel && targetModel.data && targetModel.data.state;
		void(this.props.relationship.exploreViewActivated);

		return (
			<div className="relationship-vis-view" id = { this.props.relationship.uid } >
				{this._buildStatusBar(this.props.relationship.uid)}
				{state === REJECTED ?
					<RelationshipVisErrorView
						error={targetModel.data.error}
						defaultTitle={ERROR_DEFAULT_TITLE}
						defaultDescription={ERROR_DEFAULT_DESCRIPTION}
					/> :
					null
				}
				{ 	/*
						* Ideally there should be only one Diagram Widget instance in explore perspective
						* As a result, the parent DOM container is always avaiable and mounted
						* while currently a new VIPR widget instance is created when fetchData is triggered
						* When the process is happening in a deactived perspective, VIPR widget could
						* end up with rendeering in an invisible parent container.
						* Therefore, we are remount the WidgetView when explore perspective becomes activated
						* */

					this.props.relationship.exploreViewActivated ?
						<RelationshipWidgetView relationship={this.props.relationship} services={this.props.services} fields={this.props.fields}/>
						:
						null
				}
			</div>
		);
	}

	_buildStatusBar(containerId){
		const targetModel = this.props.relationship.getTargetModel();
		const toastTarget = `${containerId}`;
		return(
			<RelationshipStatusBar
				targetModel = {targetModel}
				containerId = {toastTarget}
			/>
		);
	}
}

RelationshipVisView.propTypes = {
	relationship: PropTypes.object.isRequired,
	services:PropTypes.object,
	fields:PropTypes.object
};


export default RelationshipVisView;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipVisView.js